import React, { Component } from 'react';
import ReactDOM from "react-dom";
import ReactDataGrid from 'react-data-grid';
import { Editors, Toolbar, Data } from 'react-data-grid-addons';
import update from 'immutability-helper';

import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import { Tooltip, Fade } from '@material-ui/core';
import NumberFormat from 'react-number-format';
import FloatCellEditor from './float_grid_cell_editor';
import IntCellEditor from './int_grid_cell_editor';
import PercentCellEditor from './percent_grid_cell_editor';

import './neurite_grid.css';


const styles = theme => ({
    root: {
        margin: theme.spacing(1),
    },
    icon: {
        margin: 'auto'
    },
    newButton: {
        margin: '15px 15px 15px 0',
        padding: theme.spacing(1),
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    formControl: {
        color: '#ff0000'
    },
    oddRow: {
        backgroundColor: "#e8f1d7",
    },
    evenRow: {
        backgroundColor: "white",
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

const selectors = Data.Selectors;

const FloatCellFormatter = (value, row, admin, grayField, decimal) => {

    const styleAdmin = {
        paddingTop: 8,
        paddingRight: 2,
        textAlign: 'right',
        backgroundColor: '#db0808',
        fontWeight: 700,
        borderRadius: 5,
    };

    let isGray = false;
    if (grayField) isGray = row[grayField];
    isGray = isGray || row['total'];
    const backColor = isGray ? '#eeeeee' : 'inherit';

    //console.log(value);

    return (

        <div style={admin ? styleAdmin : { textAlign: 'right', backgroundColor: backColor }}>
            <NumberFormat value={value}
                decimalSeparator=","
                thousandSeparator="."
                isNumericString={true}
                decimalScale={decimal ? decimal : 2}
                fixedDecimalScale={true}
                displayType={'text'}
            />
        </div>

    );
};

const FloatPercentFormatter = (value, row, admin, grayField) => {

    const styleAdmin = {
        paddingTop: 8,
        paddingRight: 2,
        textAlign: 'right',
        backgroundColor: '#db0808',
        fontWeight: 700,
        borderRadius: 5,
    };

    let isGray = false;
    if (grayField) isGray = row[grayField];
    isGray = isGray || row['total'];
    const backColor = isGray ? '#eeeeee' : 'inherit';

    return (
        <div style={admin ? styleAdmin : { textAlign: 'right', backgroundColor: backColor }}>
            <NumberFormat value={value}
                decimalSeparator=","
                thousandSeparator="."
                isNumericString={true}
                decimalScale={2}
                fixedDecimalScale={true}
                displayType={'text'}
                suffix={'%'}
            />
        </div>
    );
};

const IntCellFormatter = (value, row, admin, grayField) => {
    const styleAdmin = {
        paddingTop: 8,
        paddingRight: 2,
        textAlign: 'right',
        backgroundColor: '#db0808',
        fontWeight: 700,
        borderRadius: 5,
    };

    let isGray = false;
    if (grayField) isGray = row[grayField];
    isGray = isGray || row['total'];
    const backColor = isGray ? '#eeeeee' : 'inherit';

    return (
        <div style={admin ? styleAdmin : { textAlign: 'right', backgroundColor: backColor }}>
            <NumberFormat value={value}
                decimalSeparator=","
                thousandSeparator="."
                isNumericString={true}
                decimalScale={0}
                displayType={'text'}
            />
        </div>
    );

};

const CustomFormatter = (value, row, admin, grayField) => {

    const style = {
        backgroundColor: '#db0808',
        fontWeight: 700,
        borderRadius: 5,
    };

    let isGray = false;
    if (grayField) isGray = row[grayField];
    isGray = isGray || row['total'];
    const backColor = isGray ? '#eeeeee' : 'inherit';

    return <div style={admin ? style : { backgroundColor: backColor, fontSize: 11 }}>{value}</div>
}

const OptionsFormatter = (value, row, admin, grayField, options) => {

    const style = {
        backgroundColor: '#db0808',
        fontWeight: 700,
        borderRadius: 5,
    };

    let isGray = false;
    if (grayField) isGray = row[grayField];
    isGray = isGray || row['total'];
    const backColor = isGray ? '#eeeeee' : 'inherit';

    let val = '';
    if (value) {
        const selected = options.find(o => o.id === Number(value));
        if (selected !== undefined) val = selected.text;
    }
    return <div style={admin ? style : { backgroundColor: backColor }}>{val}</div>
}

const DateFormatter = (value, row, admin, grayField) => {
    if (value) {
        let d = new Date(value.slice(0, 10)).toLocaleDateString("es-ES", { year: "numeric", month: "2-digit", day: "2-digit" })+
                ' '+ value.slice(11,19) // añadido para KD
        return d;
    } else {
        return 'Sin fecha';
    }
};

const sortRows = (initialRows, sortColumn, sortDirection, rows) => {

    const comparer = (a, b) => {
        if (sortDirection === "ASC") {
            return a[sortColumn] > b[sortColumn] ? 1 : -1;
        } else if (sortDirection === "DESC") {
            return a[sortColumn] < b[sortColumn] ? 1 : -1;
        }
    };
    return sortDirection === "NONE" ? initialRows.map((r, i) => { return { ...r, grid_index: i } }) : [...rows].sort(comparer);
};


const handleFilterChange = (filter, filters, id) => {
    const newFilters = { ...filters };
    if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
    } else {
        delete newFilters[filter.column.key];
    }
    localStorage.setItem(window.location.pathname + id, JSON.stringify(newFilters));
    return newFilters;
};

function getRows(rows, filters) {
    return selectors.getRows({ rows, filters });
}


class NeuriteGrid extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            rows: this.props.rows.map((r, i) => { return { ...r, grid_index: i } }),
            columns: this.processColumns(),
            selectedIndexes: this.props.selectedIndexes ? this.props.selectedIndexes : [],
            selectedIds: this.props.selectedIndexes ? this.props.selectedIndexes.map(i => this.props.rows[i].id) : [],
            filters: {},
            parent: null,
            sortColumn: null,
            sortDirection: 'NONE',
        };
        this.controlUpdate = 0;

    };

    processColumns = () => {
        const columns = this.props.columns.slice();

        const { CheckboxEditor } = Editors;
        const { DropDownEditor } = Editors;

        columns.forEach((col) => {
            if (col.type !== undefined) {
                switch (col.type) {
                    case 'bool':
                        col.formatter = <CheckboxEditor readOnly />
                        col.onCellChange = (rowIdx, columnKey, e) => this.handleCheckbox(rowIdx, columnKey, e, col.editable)
                        break;
                    case 'more':
                        //col.name = '';
                        col.width = 40;
                        col.editable = false;
                        break;
                    case 'launch':
                        //col.name = '';
                        col.width = 40;
                        col.editable = false;
                        break;
                    case 'float':
                        col.formatter = ({ value, row }) => FloatCellFormatter(value, row, col.admin, col.grayField, col.decimal);
                        if (col.editable) col.editor = FloatCellEditor;
                        break;
                    case 'int':
                        col.formatter = ({ value, row }) => IntCellFormatter(value, row, col.admin, col.grayField);
                        if (col.editable) col.editor = IntCellEditor;
                        break;
                    case 'percent':
                        col.formatter = ({ value, row }) => FloatPercentFormatter(value, row, col.admin, col.grayField);
                        if (col.editable) col.editor = PercentCellEditor;
                        break;
                    case 'date':
                        col.width = 130; // fbp para que quepa el formato con hh:mm:ss (KD)
                        col.formatter = ({ value, row }) => DateFormatter(value, row, col.admin, col.grayField);
                        break;
                    case 'dropdown':
                        if (col.editable) col.editor = <DropDownEditor options={this.props.dropdownOptions[col.key]} />
                        col.formatter = ({ value, row }) => OptionsFormatter(value, row, col.admin, col.grayField, this.props.dropdownOptions[col.key]);
                        break;
                    default:
                        col.formatter = ({ value, row }) => CustomFormatter(value, row, col.admin, col.grayField);
                        break;
                };
            }
            else {
                col.formatter = ({ value, row }) => CustomFormatter(value, row, col.admin, col.grayField);
            }

            col.headerRenderer = <span title={col.tooltip}> {col.name} </span>;

        });


        if (this.props.buttonEdit) {
            columns.push({
                key: 'edit',
                name: '',
                editable: false,
                width: 40,
            });
        };

        if (this.props.buttonDelete) {
            columns.push({
                key: 'delete',
                name: '',
                editable: false,
                width: 40,
            });
        };

        columns.forEach(col => {
            if (!col.width) col.width = 150;
            col.sortable = true;
            col.filterable = true;
        });

        return columns;
    };


    handleCheckbox = (rowIdx, columnKey, e, editable) => {

        const filteredRows = getRows(this.state.rows, this.state.filters);

        const index = filteredRows[rowIdx].grid_index;

        if (editable) {
            this.props.onRowsUpdated ? this.props.onRowsUpdated({
                fromRow: index, toRow: index, fromRowData: filteredRows[rowIdx], updated: { [columnKey]: !this.state.rows[index][columnKey] }
            }) : this.handleGridRowsUpdated({
                fromRow: index, toRow: index, fromRowData: filteredRows[rowIdx], updated: { [columnKey]: !this.state.rows[index][columnKey] }
            })
        };
    };

    componentDidMount() {

        var parent = ReactDOM.findDOMNode(this).getElementsByClassName("react-grid-Grid")[0];

        const d = new Date();
        const miliseconds = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());

        if (this.grid !== undefined && this.grid.selectAllCheckbox !== undefined && this.grid.selectAllCheckbox.id === 'select-all-checkbox') {
            this.grid.selectAllCheckbox.id += `-${miliseconds}`;
            this.grid.selectAllCheckbox.nextSibling.htmlFor += `-${miliseconds}`;
        }
        this.setState({
            ...this.state, parent: parent,
            filters: JSON.parse(localStorage.getItem(window.location.pathname + this.props.id))
        });

    }



    componentDidUpdate(prevProps, prevState, snapshot) {

        if (prevProps.rows !== this.props.rows || prevProps.columns !== this.props.columns || prevProps.selectedIndexes !== this.props.selectedIndexes) {

            const rows = this.props.rows.map((r, i) => { return { ...r, grid_index: i } });

            this.setState({
                ...this.state,
                rows: sortRows(rows, this.state.sortColumn, this.state.sortDirection, rows),
                columns: this.processColumns(),
                selectedIds: this.props.selectedIndexes ? this.props.selectedIndexes.map(i => this.props.rows[i].id) : [],
            });

        };
        if (document.activeElement.id === 'grid_button_new') {
            this.myActions.focusVisible();
        }

    };


    handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {

        const rows = this.state.rows.slice();

        for (let i = fromRow; i <= toRow; i++) {
            let rowToUpdate = rows[i];
            let updatedRow = update(rowToUpdate, { $merge: updated });
            rows[i] = updatedRow;
        };

        this.setState({ rows });
    };

    handleDeleteRow = (row, indexToDelete) => {

        const rows = this.state.rows.filter((row, rowIndex) => rowIndex !== indexToDelete);

        this.setState({ rows });

    };

    handleAddNewRow = ({ updated }) => {

        let rows = this.state.rows.slice();
        rows.push(updated);
        this.setState({ rows });

    };

    handleNewRowClick = () => {
        this.handleAddNewRow({});
    };

    getCellActions = (column, row) => {

        const { classes } = this.props;

        if (column.key === 'edit') {
            return [
                {
                    icon: <Icon className={classes.icon}>edit</Icon>,
                    callback: () => {

                        this.props.onEditClick(row)

                    }

                }
            ];
        };
        if (column.key === 'delete') {
            return [
                {
                    icon: <Icon className={classes.icon}>delete</Icon>,
                    callback: () => {
                        if (this.props.onDeleteClick) this.props.onDeleteClick(row, row._index);
                        else this.handleDeleteRow(row, row._index);
                    }
                }
            ];

        };

        if (column.type === 'more') {
            return [
                {
                    icon: <Icon className={classes.icon} >notes</Icon>,
                    callback: () => {
                        column.handleMoreClick(row);
                    }
                }
            ];
        };

        if (column.type === 'launch') {
            return [
                {
                    icon: <Icon className={classes.icon} title={column.name.props ? column.name.props.title : ""} >{column.icon ? column.icon : "launch"}</Icon>,

                    callback: () => {
                        column.handleLaunchClick(row);
                    }
                }
            ];
        };

    };

    onRowsSelected = rows => {

        if (this.props.selectByKeys === true) {

            let selectedIds = this.state.selectedIds.concat(
                rows.map(r => r.row.id)
            );

            this.setState({
                selectedIds: selectedIds
            });

            if (this.props.onSelection) this.props.onSelection(selectedIds);

        }
        else {
            let selectedIndexes = this.state.selectedIndexes.concat(
                //rows.map(r => r.rowIdx)
                rows.map(r => r.row.grid_index)
            );

            this.setState({
                selectedIndexes: selectedIndexes
            });

            if (this.props.onSelection) this.props.onSelection(selectedIndexes);

        }

    };

    onRowsDeselected = rows => {

        if (this.props.selectByKeys === true) {

            let rowIds = rows.map(r => r.row.id);

            let selectedIds = this.state.selectedIds.filter(
                id => !rowIds.includes(id)
            );

            this.setState({
                selectedIds: selectedIds
            });

            if (this.props.onSelection) this.props.onSelection(selectedIds);
        }
        else {
            //let rowIndexes = rows.map(r => r.rowIdx);
            let rowIndexes = rows.map(r => r.row.grid_index);

            let selectedIndexes = this.state.selectedIndexes.filter(
                i => rowIndexes.indexOf(i) === -1
            );

            this.setState({
                selectedIndexes: selectedIndexes
            });

            if (this.props.onSelection) this.props.onSelection(selectedIndexes);
        }

    };


    width = () => {

        const maxWidth = this.props.width ? this.props.width : 1100;

        let sumedWidths = 0;

        if (this.state.columns.length) {

            this.state.columns.forEach(col => {
                sumedWidths += col.width
            });
        };

        let result = (sumedWidths && sumedWidths < maxWidth) ? sumedWidths : maxWidth;

        if (this.props.enableSelection) result += 60;

        result += 20; //scrollbar

        return result;

    };

    RowRenderer = ({ renderBaseRow, ...props }) => {

        const { classes } = this.props;

        return <div className={props.idx % 2 ? classes.oddRow : classes.evenRow}>{renderBaseRow(props)}</div>

    };

    downloadCsvData = (columns, rows) => {
        var csvData = '';
        columns.forEach(c => {
            csvData += c.name + ';';
        });
        csvData = csvData.slice(0, -1);
        csvData += '\n';

        rows.forEach((r, i) => {

            columns.forEach(c => {

                let strValue = '';

                if (r[c.name] !== undefined && r[c.name] !== null) {

                    switch (c.type) {
                        case 'int':
                            strValue = r[c.name].toString();
                            break;
                        case 'float':
                            strValue = r[c.name].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                            break;
                        case 'date':
                            strValue = new Date(r[c.name].slice(0, 10)).toLocaleDateString("es-ES", { year: "numeric", month: "2-digit", day: "2-digit" })
                                        +' '+ r[c.name].slice(11,19) // añadido para KD
                            ;
                            break;
                        default:
                            strValue = r[c.name];
                            break;
                    }
                }

                csvData += strValue + ';';

            });

            csvData = csvData.slice(0, -1);
            csvData += '\n';

        })

        const link = document.createElement('a');
        link.href = 'data:text/csv;charset=ISO-8859-1,' + encodeURIComponent(csvData);
        link.setAttribute('download', 'dataset.csv');
        document.body.appendChild(link);
        link.click();
    }

    calculateTotal = (rows) => {

        var newRow = {};

        this.state.columns.forEach((c, i) => {

            if (c.type === 'float') {
                newRow[c.name] = 0.0;
            }
            else if (c.type === 'int') {
                newRow[c.name] = 0;
            }
            else {
                newRow[c.name] = '';
            }

        });

        rows.forEach((r) => {

            this.state.columns.forEach((c) => {
                if (c.type === 'int' || c.type === 'float') {
                    newRow[c.name] += r[c.name];
                }
            });

        });

        newRow['total'] = true;

        return newRow;

    }
    onRowsUpdatedController = rowAtr => {
        let currentColumnIndex = 0;
        let lastColumnIndex = 0;
        Object.entries(this.state.columns).forEach(([key, value]) => {
            if (rowAtr.cellKey === value.key) {
                currentColumnIndex = key;
            }
            lastColumnIndex = key;
        });
        let currentRowIndex = rowAtr.toRow;
        let lastRowIndex = this.state.rows.length - 1;
        if (currentRowIndex !== lastRowIndex && this.controlUpdate === 0) {
            if (this.props.tabulation) {
                this.grid.openCellEditor(currentRowIndex + 1, currentColumnIndex);
            } else { //TODO - falla al intentar abrir el cell editor de la comuna contigua
                //this.grid.openCellEditor(currentColumnIndex === lastColumnIndex ? currentRowIndex + 1 : currentRowIndex, currentColumnIndex === lastColumnIndex ? 0 : currentColumnIndex + 1);
            }
        }

        this.controlUpdate++;
        if (this.controlUpdate === 2) {
            this.controlUpdate = 0;
        }

        this.props.onRowsUpdated(rowAtr);
    }

    render() {

        const { classes, buttonNew } = this.props;
        const rowHeight = this.props.rowHeight ? this.props.rowHeight : 35;

        const filteredRows = getRows(this.state.rows, this.state.filters);

        if (this.props.addTotal) {
            if (filteredRows.length > 0 && filteredRows[filteredRows.length - 1]['total'] === true) filteredRows.pop();
            filteredRows.push(this.calculateTotal(filteredRows));
        }

        return (
            <div className={classes.root} style={{ fontSize: this.props.fontSize ? this.props.fontSize : 12, maxWidth: this.width() }} >
                <ReactDataGrid
                    ref={node => this.grid = node}
                    enableCellSelect={true}
                    columns={this.state.columns}
                    rowGetter={(i) => {
                        return { ...filteredRows[i], _index: i, };
                    }}
                    rowsCount={filteredRows.length}
                    rowRenderer={this.props.alternateRows ? this.RowRenderer : ''}
                    minHeight={this.props.height ? this.props.height : (this.state.rows.length + 1) * rowHeight + 10}
                    onGridRowsUpdated={this.props.onRowsUpdated ? this.onRowsUpdatedController : this.handleGridRowsUpdated}
                    getCellActions={this.getCellActions}
                    rowSelection={this.props.selectByKeys ?
                        {
                            showCheckbox: this.props.enableSelection ? this.props.enableSelection : false,
                            enableShiftSelect: false,
                            onRowsSelected: this.onRowsSelected,
                            onRowsDeselected: this.onRowsDeselected,
                            selectBy: {
                                //indexes: this.state.selectedIndexes
                                keys: {
                                    rowKey: 'id',
                                    values: this.state.selectedIds
                                }
                            }
                        } :
                        {
                            showCheckbox: this.props.enableSelection ? this.props.enableSelection : false,
                            enableShiftSelect: false,
                            onRowsSelected: this.onRowsSelected,
                            onRowsDeselected: this.onRowsDeselected,
                            selectBy: {
                                //indexes: this.state.selectedIndexes
                                keys: {
                                    rowKey: 'grid_index',
                                    values: this.state.selectedIndexes
                                }
                            }
                        }
                    }
                    onGridSort={(sortColumn, sortDirection) => {
                        this.setState({ ...this.state, sortColumn, sortDirection, rows: sortRows(this.props.rows, sortColumn, sortDirection, this.state.rows) });
                    }}
                    toolbar={this.props.enableFilter ? <Toolbar enableFilter={true} /> : ''}
                    onAddFilter={filter => this.setState({ ...this.state, filters: handleFilterChange(filter, this.state.filters, this.props.id) })}
                    onClearFilters={() => { localStorage.removeItem(window.location.pathname + this.props.id); this.setState({ ...this.state, filters: {} }) }}
                    onCellSelected={this.props.cellSelectedHandler ?
                        ({ rowIdx, idx }) => {
                            this.props.cellSelectedHandler(filteredRows[rowIdx], this.state.columns[idx]);
                        }
                        :
                        ''
                    }
                    scrollToRowIndex={this.props.last ? filteredRows.length : 0}
                    editorPortalTarget={this.state.parent}
                />

                <div>
                    {this.props.tooltipNew ?
                        <Tooltip title={this.props.tooltipNew} TransitionComponent={Fade} TransitionProps={{ timeout: 500 }} placement="right" classes={{ tooltip: this.props.classes.tooltip }}>
                            <Button hidden={!buttonNew} variant="contained" color="primary" className={classes.newButton} id={'grid_button_new'} action={(actions) => this.myActions = actions}
                                onClick={this.props.onNewRowClick ? this.props.onNewRowClick : this.handleNewRowClick}
                            >Nuevo</Button>
                        </Tooltip>
                        :
                        <Button hidden={!buttonNew} variant="contained" color="primary" className={classes.newButton} id={'grid_button_new'} action={(actions) => this.myActions = actions}
                            onClick={this.props.onNewRowClick ? this.props.onNewRowClick : this.handleNewRowClick}
                        >Nuevo</Button>
                    }
                    <Button hidden={!this.props.buttonCSV} variant="contained" color="secondary" className={classes.newButton} id={'grid_button_csv'}
                        onClick={() => this.downloadCsvData(this.state.columns, filteredRows)}
                    >Exportar a CSV</Button>
                </div>
            </div>
        );
    };
};

NeuriteGrid.propTypes = {
    columns: PropTypes.array.isRequired,
    rows: PropTypes.array.isRequired,
    buttonEdit: PropTypes.bool.isRequired,
    buttonDelete: PropTypes.bool.isRequired,
    height: PropTypes.number,
    onEditClick: PropTypes.func,
    onDeleteClick: PropTypes.func,
    onNewRowClick: PropTypes.func,
    onRowsUpdated: PropTypes.func,
    fontSize: PropTypes.number,
    alternateRows: PropTypes.bool,
    enableSelection: PropTypes.bool,
    tooltipNew: PropTypes.string,
    onSelection: PropTypes.func,
    width: PropTypes.number,
    enableFilter: PropTypes.bool,
    tooltipFilter: PropTypes.string,
    rowHeight: PropTypes.number,
    buttonCSV: PropTypes.bool,
    addTotal: PropTypes.bool

};


export default withStyles(styles, { withTheme: true })(NeuriteGrid);